export const tags = [
  {
    label: '语言能力',
    key: 'language',
    children: ['英文-1-母语水平', '英文-2-工作语言', '英文-3-可顺利读写，口语较弱', '粤语', '日语', '法语', '小语种'],
    checkList: [],
  },
  {
    label: '领导力',
    key: 'leadership',
    children: ['领导力强', '领导力弱', '逆商高', '逆商低', '强资源人脉'],
    checkList: [],
  },
  {
    label: '个人风格',
    key: 'personal',
    children: [
      '保守',
      '稳健',
      '开拓（追求卓越）',
      '激进（狼性文化）',
      'social型',
      '学术研究型',
      '适合美元',
      '适合人民币',
      '具有创业精神',
      '情商高',
      '校友资源型',
      '政府资源型',
    ],
    checkList: [],
  },
  {
    label: '专业因素',
    key: 'professional',
    children: [
      '专业能力强',
      '销售能力强',
      '研究功底扎实',
      '逻辑思维强',
      '思维散乱',
      '沟通能力强',
      '表达能力弱',
      '商业意识强',
      '执行力强',
    ],
    checkList: [],
  },
  {
    label: '心态、个性',
    key: 'mentality',
    children: [
      '心态积极正向',
      '消极负面',
      '战略思维、注重长远',
      '看重短期',
      '事业心强',
      '追求家庭工作平衡',
      '追求创新',
      '个性求稳',
      '积极进取',
      '结果导向',
    ],
    checkList: [],
  },
  {
    label: '自定义标签',
    key: 'other',
    checkList: [],
  },
]
